// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CustomerOrderDetailPage.css — page-specific overrides */
/* All shared layout, typography, buttons, and modals
   live in AdventureShared.css */

.adv-detail-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  gap: 20px;
}

.adv-detail-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.08);
  border-top-color: #00f2fe;
  border-radius: 50%;
  animation: adv-spin 1s linear infinite;
  box-shadow: 0 0 15px rgba(0, 242, 254, 0.15);
}

@keyframes adv-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.clickable-provider-card {
  transition: background-color 0.2s, border-color 0.2s, transform 0.2s;
}

.clickable-provider-card:hover {
  background: rgba(255, 255, 255, 0.03) !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  transform: translateY(-2px);
}
`, "",{"version":3,"sources":["webpack://./src/Pages/CustomerOrderDetailPage/CustomerOrderDetailPage.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;gCACgC;;AAEhC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;;AAGA;EACE,oEAAoE;AACtE;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;EAClD,2BAA2B;AAC7B","sourcesContent":["/* CustomerOrderDetailPage.css — page-specific overrides */\n/* All shared layout, typography, buttons, and modals\n   live in AdventureShared.css */\n\n.adv-detail-spinner-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 100px 0;\n  gap: 20px;\n}\n\n.adv-detail-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(255, 255, 255, 0.08);\n  border-top-color: #00f2fe;\n  border-radius: 50%;\n  animation: adv-spin 1s linear infinite;\n  box-shadow: 0 0 15px rgba(0, 242, 254, 0.15);\n}\n\n@keyframes adv-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n.clickable-provider-card {\n  transition: background-color 0.2s, border-color 0.2s, transform 0.2s;\n}\n\n.clickable-provider-card:hover {\n  background: rgba(255, 255, 255, 0.03) !important;\n  border-color: rgba(255, 255, 255, 0.08) !important;\n  transform: translateY(-2px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
